/**
 * Just a central logging location, a stub for any future fancy logger
 */
import * as log from 'loglevel'
import { getErrorStack } from './errors'

export function consoleLog(...args: unknown[]) {
  // inject timestamp when no debugger attach
  // const timestamp: string = new Date().toISOString();
  // console.log(`[${timestamp}]` , ...args)
  console.log(...args)
}

export function debug(...args: unknown[]) {
  consoleLog(...args)
  log.debug(...args)
}

export function info(...args: unknown[]) {
  consoleLog(...args)
  log.info(...args)
}

export function warn(...args: unknown[]) {
  consoleLog(...args)
  log.warn( ...args)
}

export function error(...args: unknown[]) {
  consoleLog(...args)
  log.error( ...args)
}

export function getLogger(name: string | symbol) {
  const ret = log.getLogger(name)
  ret.setLevel(log.levels.INFO)
  return ret
}

export function setLogger(
  logger: log.Logger,
  newLogger: (message: unknown, args: unknown) => void
) {
  const origFactory = logger.methodFactory
  logger.methodFactory = function (
    methodName: string,
    logLevel: log.LogLevelNumbers,
    loggerName: string | symbol
  ) {
    const origMethod = origFactory(methodName, logLevel, loggerName)
    return function (message: unknown, ...args: unknown[]) {
      try {
        origMethod?.(message, args)
        newLogger?.(message, args?.[0])
      } catch (e) {
        console.error(`sematext log failed: ${getErrorStack(e)}`)
      }
    }
  }
  // necessary to refresh the log method
  logger.setLevel(logger.getLevel())
}
